'use client';

import { Box } from '@mantine/core';
import clsx from 'clsx';
import Starfield from 'react-starfield';

import s from './starfield-background.module.scss';

export default function StarfieldBackground() {
	return (
		<>
			<Box className={clsx(s.background)} />
			<Box className={s.starfield}>
				<Starfield backgroundColor="black" starCount={400} />
			</Box>
		</>
	);
}
